import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Select } from 'components/atoms/select';
import { Box, TimesheetSettingTable } from '../components';

export const UserListSelect = styled(Select)`
  flex: 1;
`;
export const AddExclusionWrapper = styled(Box)`
  gap: 0;
  margin-bottom: var(--layout-03);
`;
export const RoleAndActionColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
`;
export const UsersTable = styled(TimesheetSettingTable)`
  .ant-table-placeholder {
    text-align: left;

    .ant-table-cell {
      padding: var(--layout-05) var(--spacing-05) var(--spacing-05);
      color: var(--gray-70);
      border: 0;
    }
  }
  .ant-table-row {
    transition: background-color 0.3s linear;
    &.highlight {
      background-color: var(--blue-10);
    }
    ${RoleAndActionColumn} ${Button} {
      display: none;
    }
    &:hover {
      ${RoleAndActionColumn} ${Button} {
        display: inline-block;
      }
    }
  }
`;
